export default __webpack_public_path__ + "static/media/administration.678a01b9.svg";